var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocMios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "52px",
    viewBox: "0 0 40 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Documents-uploadFile",
    transform: "translate(-303.000000, -460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-otherFile",
    transform: "translate(303.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F7F7F7",
    fillRule: "nonzero",
    points: "0 0 31.659919 0 40 8.45328283 40 52 0 52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(8.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06568473,15.334314 L1.06568473,15.334314 C0.0487958366,14.7469489 -0.302505751,13.4353298 0.284160916,12.4191394 L6.75984346,1.20332985 C7.34720854,0.186440959 8.65882758,-0.164860629 9.67501806,0.421806038 C10.6919069,1.0084727 11.0432085,2.32079017 10.4565419,3.33698064 L3.98085933,14.5534886 C3.39349425,15.5696791 2.0818752,15.9209806 1.06568473,15.334314",
    id: "Fill-1",
    fill: "#53BE93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7372911,15.1965171 L22.7372911,15.1965171 C23.75418,14.6098505 24.1054816,13.297533 23.5188149,12.2813425 L17.0431323,1.06553302 C16.4557673,0.049342546 15.1441482,-0.302657454 14.1279577,0.284009213 C13.1110689,0.871374292 12.7597673,2.18299334 13.3464339,3.19918382 L19.8221165,14.4156918 C20.4094816,15.4318822 21.7211006,15.7838822 22.7372911,15.1965171",
    id: "Fill-4",
    fill: "#1DB4CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3720974,15.5860219 L16.3720974,15.5860219 C17.3889863,14.9993552 17.7402879,13.6877362 17.1536212,12.6708473 L13.7272085,6.73713302 C13.1405419,5.72024413 11.8289228,5.36894255 10.8120339,5.95560921 C9.79514504,6.54227588 9.44454187,7.85459334 10.0312085,8.87078382 L13.4569228,14.8051965 C14.0442879,15.821387 15.3559069,16.173387 16.3720974,15.5860219",
    id: "Fill-7",
    fill: "#53BE93"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1DB4CF",
    fillRule: "nonzero",
    points: "2.62900812e-13 1.60760294e-13 31.5322581 1.60760294e-13 39.8387097 8.30645161 39.8387097 12.2903226 2.62900812e-13 12.2903226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEC",
    fillRule: "nonzero",
    points: "31.5322581 4.39648318e-14 31.5322581 8.30645161 39.8387097 8.30645161"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocMios);
export default __webpack_public_path__ + "static/media/icDocMIOS.9d0fe8dd2803e5b17538ccb08072344b.svg";
export { ForwardRef as ReactComponent };